import React from 'react';
import PropTypes from 'prop-types';

import RatingCell from './RatingCell';
import RecentResultsCell from './RecentResultsCell';
import EventActivityCell from './EventActivityCell';
import PlayerIdentity from './PlayerIdentity';
import RowKebab from './RowKebab';
import NoteIndicator from './NoteIndicator';
import { MatchFormatTypes } from '../../../../utils/postScoreConstants';
import styles from './playersList.scss';

// Desktop table row: activity dot, identity (avatar + teal name link + M/F • Location), the two rating
// cells, the Recent Results + Event Activity cells, a reserved note-indicator slot (shown only when the
// player has a note), and the kebab shell.
const PlayerRow = ({ player, onNote, onRemove, 'data-testid': dataTestId }) => {
    const { recentActivity, recentResults, eventActivity, note } = player;

    return (
        <div className={styles.row} data-testid={dataTestId || undefined}>
            <span className={styles.activityCol}>
                {recentActivity && (
                    <span className={styles.activityDot} data-testid={dataTestId && `${dataTestId}.activity-dot`} />
                )}
            </span>
            <div className={styles.nameCol}>
                <PlayerIdentity player={player} data-testid={dataTestId} />
            </div>
            <div className={styles.singlesCol}>
                <RatingCell player={player} ratingType={MatchFormatTypes.SINGLES} data-testid={dataTestId && `${dataTestId}.singles`} />
            </div>
            <div className={styles.doublesCol}>
                <RatingCell player={player} ratingType={MatchFormatTypes.DOUBLES} data-testid={dataTestId && `${dataTestId}.doubles`} />
            </div>
            <div className={styles.recentResultsCol}>
                <RecentResultsCell results={recentResults} data-testid={dataTestId && `${dataTestId}.recent-results`} />
            </div>
            <div className={styles.eventActivityCol}>
                <EventActivityCell events={eventActivity} data-testid={dataTestId && `${dataTestId}.event-activity`} />
            </div>
            <span className={styles.noteCol}>
                {note && (
                    <NoteIndicator onClick={onNote} data-testid={dataTestId && `${dataTestId}.note-icon`} />
                )}
            </span>
            <RowKebab onNote={onNote} onRemove={onRemove} data-testid={dataTestId && `${dataTestId}.menu`} />
        </div>
    );
};

PlayerRow.propTypes = {
    player: PropTypes.instanceOf(Object).isRequired,
    onNote: PropTypes.func,
    onRemove: PropTypes.func,
    'data-testid': PropTypes.string,
};

PlayerRow.defaultProps = {
    onNote: () => {},
    onRemove: () => {},
    'data-testid': null,
};

export default PlayerRow;
